import React, { FC, PropsWithChildren } from 'react';
import { Header } from './header';
import NavBar from './nav-bar';
import FeedbackButton from './feedback-button';
import './index.module.css';
import { AppThemeListener } from '@/components/helpers/app-theme';

export const PageLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div>
      <AppThemeListener />

      <Header />
      <FeedbackButton />

      {children}

      <NavBar />
    </div>
  );
};

export default PageLayout;
